import { make } from "vuex-pathify";
import { setSubscriptionId, setSubscriptionStatus } from "../utils/auth0";
import api from "@/api";

const ACCESS_TOKEN_KEY = "access_token";

const state = {};

// automatically generate getters
const getters = make.getters(state);

const mutations = {
  ...make.mutations(state)
};

const actions = {
  ...make.actions(state),

  // eslint-disable-next-line
  getSupportPlans({}, planId) {
    return new Promise(function(resolve, reject) {
      api
        .o(
          `Subscriptions/GetSupportPlans?api-version=${api.props.versionNumber}`
        )
        .get(
          function(entity) {
            //me.RefreshReset();
            resolve(entity);
          },
          function(ex) {
            reject(ex);
          }
        );
    });
  },

  // eslint-disable-next-line
    getPlatformPlans({}) {
    return new Promise(function(resolve, reject) {
      api
        .o(
          `Subscriptions/GetPlatformPlans?api-version=${
            api.props.versionNumber
          }`
        )
        .get(
          function(entity) {
            //me.RefreshReset();
            resolve(entity);
          },
          function(ex) {
            reject(ex);
          }
        );
    });
  },

  // eslint-disable-next-line
  getHostedPage({}, hostedInfo) {
    var checkoutStep = "";
    // eslint-disable-next-line
    var chargebeeInstance = Chargebee.init({
      site: api.props.config.chargeBee.site
    });
    chargebeeInstance.openCheckout({
      hostedPage: () => {
        // eslint-disable-next-line
        return axios
          .get(
            api.props.config.serviceBase +
              "/chargebee/hostedpage?api-version=1.0",
            {
              params: hostedInfo,
              headers: {
                Authorization:
                  "bearer " + localStorage.getItem(ACCESS_TOKEN_KEY)
              },
              dataType: "json",
              responseType: "json"
            }
          )
          .then(response => response.data);
      },
      success: function(hostedPageId) {
        console.log("hostedpageId " + hostedPageId);
        // do a check here to get the new subscription Id and set it to local storage
        // eslint-disable-next-line
        axios
          .get(
            api.props.config.serviceBase + "/Subscriptions?api-version=1.0",
            {
              dataType: "json",
              responseType: "json",
              headers: {
                Authorization:
                  "bearer " + localStorage.getItem(ACCESS_TOKEN_KEY)
              }
            }
          )
          .then(response => {
            if (response.data.value.length >= 1) {
              setSubscriptionId(response.data.value[0].id);
              setSubscriptionStatus(response.data.value[0].status);
            }
          });
      },
      error: function() {
        //debugger;
      },
      loaded: function() {
        //debugger;
      },
      close: function() {
        if (
          checkoutStep !== "thankyou_screen" &&
          hostedInfo.closeUrl !== undefined &&
          hostedInfo.closeUrl !== null
        ) {
          window.location = hostedInfo.closeUrl;
          window.location.reload();
          return;
        }
        if (
          checkoutStep === "thankyou_screen" &&
          hostedInfo.completeUrl !== undefined &&
          hostedInfo.completeUrl !== null
        ) {
          window.location = hostedInfo.completeUrl;
          window.location.reload();
          return;
        }
        window.location.replace("?update=true#/subscription");
        window.history.pushState(
          {},
          document.title,
          "?update=true#/subscription"
        );
        window.location.reload();
      },
      step: function(value) {
        checkoutStep = value;
        console.log("current checkout step " + value);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
